export default __webpack_public_path__ + "static/bgContactGreen-ed3409308dceee2a41f5a1f604f29fc1.png";